var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oci-container-pj"},[_c('div',{staticClass:"oci-header"},[_c('b-row')],1),_c('hr',{staticClass:"w-100"}),_c('div',{staticClass:"wrapper"})])}
var staticRenderFns = []

export { render, staticRenderFns }